<template>
  <base-form
    ref="form"
    has-captcha="send"
    :items.sync="data"
    label-width="2em"
    submit-text="登 录"
    @submit="onSubmit"
  />
</template>

<script>
import { mixinForward } from "@/mixins/mixinForward";
import { mapActions } from "vuex";
import BaseForm from "@/components/BaseForm";
export default {
  name: "MobilePhone",
  components: {
    BaseForm
  },
  data() {
    return {
      data: [
        { name: "iconPhone" },
        {
          name: "iconPhoneCode",
          type: 99,
          moduleType: false
        }
      ],
      disabled: false // 提交按钮禁用状态
    };
  },
  mixins: [mixinForward],
  mounted() {
    this.data[0].value = this.$route.query.phone ? this.$route.query.phone : "";
  },
  methods: {
    ...mapActions(["PhoneLogin"]),
    /**
     * @description 步骤提交
     * @param {object} formdata  - 表单对象值
     */
    onSubmit(formdata) {
      let { iconPhone, iconPhoneCode } = formdata;
      const parmas = {
        phone: iconPhone,
        code: iconPhoneCode,
        type: 99 //手机账号登陆传99
      };
      this.PhoneLogin(parmas)
        .then(res => {
          if (res.rcode == 0) {
            if (this.forward) {
              location.href = this.forward;
            } else {
              this.$router.replace(
                this.$route.query.redirect || {
                  path: this._anchor.profile.path
                }
              );
            }
          } else if (res.rcode == 2016) {
            this.$router.push({
              path: this._anchor.registered.path,
              query: {
                iconPhone: iconPhone,
                iconPhoneCode: iconPhoneCode
              }
            });
          }
        })
        .catch(() => {})
        .finally(() => {
          if (this.$refs.form) {
            this.$refs.form.validator.reset();
            this.$refs.form.disabled = false;
          }
        });
    }
  }
};
</script>
